@if (innerForm) {
  <form [formGroup]="innerForm">
    @if (!noLabel) {
      <label [for]="domID" class="margin-bottom-sm" [ngClass]="{ required: required, 'fw-bold': !required }">
        {{ label | translate }}
        @if (required) {
          <span class="color-error">*</span>
        }
        @if (description) {
          <p class="multiselect-description">{{ description }}</p>
        }
      </label>
    }
    <input
      #inputElement
      type="text"
      class="w-100 form-control form-element"
      [class.multi-select-form-error]="errorMessage"
      [formControlName]="innerInputName"
      [id]="domID"
      [ngbTypeahead]="search"
      (selectItem)="pushOnItemSelected($event)"
      (keyup.enter)="pushOnEnter()"
      [class.ng-invalid]="form?.get(formControlName).invalid"
      [attr.required]="required"
      [attr.aria-describedby]="formControlName + '_error'"
    />
    @if (errorMessage) {
      <div class="error-message my-1" role="alert">
        <ds-icon class="no-connection-icon me-1 error-message" [icon]="Icons.CircleExclamation"></ds-icon>
        {{ errorMessage | translate }}
      </div>
    }
    @if (form) {
      <div aria-live="polite" role="status" [id]="formControlName + '_error'" class="error-container">
        <app-form-field-error
          [formValidationRequest$]="formValidationRequest$"
          [field]="form.get(formControlName)"
          [name]="formControlName"
          [label]="label"
        ></app-form-field-error>
      </div>
    }
    <div>
      <div class="margin-bottom margin-top">
        @if (selectedLabel) {
          <div class="my-2">
            <label class="fw-bold">{{ selectedLabel | translate }}</label>
          </div>
        }
        <div class="selected-values-wrapper" [class.vertical-layout]="verticalLayout">
          @for (selectedValue of selectedValues; track selectedValue; let i = $index) {
            <div [attr.id]="'selectedValue_' + i" class="value-button">
              <span
                class="value-button-text"
                [appTooltip]="getTooltipText(selectedValue)"
                [class.value-button-text-truncated]="SharedCommonUtility.notNullish(getTooltipText(selectedValue))"
                [attr.aria-label]="valueToSelectedItemLabelFunction(selectedValue)"
              >
                {{ getDisplayText(selectedValue) }}
              </span>
              <button
                type="button"
                class="my-auto remove-value-btn"
                [attr.aria-describedby]="'selectedValue_' + i"
                (click)="removeValue(selectedValue)"
              >
                <span class="visuallyhidden">{{ 'remove_selected_value' | translate }}</span>
                <svg>
                  <use xlink:href="#circle-x"></use>
                </svg>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </form>
}
